module.exports = __webpack_public_path__ + "img/omg.f97b28c9.svg";